import request from './request'

//Para cada módulo crear un archivo con las requests necesarias, para exportarlas y llamarlas desde el componente correspondiente

export function logIn(username, password){
    return request({
        url:'/iniciar-sesion',
        method:'POST',
        data:{
            email: username,
            password: password
        }
    })
}
